import { render, staticRenderFns } from "./EditGuestPopup.vue?vue&type=template&id=20636766&scoped=true"
import script from "./EditGuestPopup.vue?vue&type=script&lang=js"
export * from "./EditGuestPopup.vue?vue&type=script&lang=js"
import style0 from "./EditGuestPopup.vue?vue&type=style&index=0&id=20636766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20636766",
  null
  
)

export default component.exports